import React, { useEffect } from 'react';
import { Row, Col, Input, Form, Button, Alert, message, Select, notification } from 'antd';
import { useUpdateAdminMutation } from '../../../app/api/adminApiSlice';
import Admin from '../../../core/models/Admin';

const Option = Select.Option;

interface EditAdminFormProps {
  admin?: Admin;
  onSuccessfulSubmit: () => void;
  handleIsLoading: (isLoading: boolean) => void;
}

const EditAdminForm = ({
  admin,
  onSuccessfulSubmit,
  handleIsLoading,
}: EditAdminFormProps): JSX.Element => {
  const [form] = Form.useForm();
  const [updateAdmin, { isLoading, isError, error }] = useUpdateAdminMutation();

  useEffect(() => {
    handleIsLoading(isLoading);
  }, [isLoading]);

  const handleEditAdmin = (values: any): void => {
    let updatedAdmin: Admin;

    if (admin) {
      updatedAdmin = { ...admin };
      Object.assign(updatedAdmin, values);
    } else {
      updatedAdmin = values;
    }

    updateAdmin(updatedAdmin)
      .unwrap()
      .then(() => {
        form.resetFields();
        notification.success({
          message: 'Success',
          description: admin ? 'Profile updated successfully' : 'Profile added successfully',
        });
        onSuccessfulSubmit();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {isError && <Alert message={error?.data?.errors?.[0]?.errorMessage} type='error' />}
      <Form
        form={form}
        id='editAdminForm'
        layout='vertical'
        initialValues={{ ...admin }}
        onFinish={handleEditAdmin}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name='firstName'
              label='First Name'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input placeholder='First Name' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name='lastName'
              label='Last Name'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input placeholder='Last Name' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name='email' label='Email' rules={[{ required: true, message: 'Required' }]}>
              <Input placeholder='Email' type='email' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name='phoneNumber'
              label='Phone Number'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Input placeholder='Phone Number' />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name={['status', 'id']}
              label='Status'
              rules={[{ required: true, message: 'Required' }]}
            >
              <Select placeholder='Status'>
                <Option value={1}>Active</Option>
                <Option value={2}>Inactive</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default EditAdminForm;
